import { httpClient } from '@/services/http/httpClient'

export type LinkTagToProjectProps = {
  tagId: string
  projectId: string
}

export const linkTagToProject = async ({
  tagId,
  projectId,
}: LinkTagToProjectProps) => {
  return await httpClient.post(`/projects/portfolio-tags/link-to-project`, {
    projectId,
    tagId,
  })
}
